import cookieUtils from '@/utils/cookieUtils';
import { COOKIE_NAME_TOKEN, COOKIE_NAME_USER_INFO, SETISLOGIN, setIsLogin, SETUSERINF, SetUserInf, SETUSERINFCENTER } from '../../actions/login';

const initState = {
    isLogin: "",
}
export const loginStateReducer = (state = initState, action) => {
    switch (action.type) {
        case SETISLOGIN:
            return {
                ...state,
                isLogin: action.state
            }
        default:
            let token = cookieUtils.get(COOKIE_NAME_TOKEN);
            if (token) {
                return {isLogin: token};
            } else {
                return state
            }
    }
}


const initUserInfState = {
    userInfo: {}
}

export const userInfStateReducer = (userInfo = initUserInfState, action) => {
    switch (action.type) {
        case SETUSERINF:
            return {
                ...userInfo,
                userInfo: action.userInfo
            }
        case SETUSERINFCENTER:
            userInfo.center = action.center;
            cookieUtils.set(COOKIE_NAME_USER_INFO, JSON.stringify(userInfo));
            return {
                ...userInfo,
                center: action.center
            }
        default:
            let uij = cookieUtils.get(COOKIE_NAME_USER_INFO);
            if (uij) {
                let ui = JSON.parse(uij);
                return { userInfo: ui };
            } else {
                return userInfo
            }
    }
}
